module.exports = __webpack_public_path__ + "media/components/assets/icons/active_red_dot-6a0700d04f991ebc2ccd8527b4074e3f.svg";